import { ArrowUpRight } from "lucide-react";
import { Wordmark } from "./Wordmark";

const LINKS = [
  { label: "Terms of Service", href: "https://wondersearch.ai/terms/", id: "terms" },
  { label: "Privacy Policy", href: "https://wondersearch.ai/privacy/", id: "privacy" },
  { label: "Security Disclosure", href: "https://wondersearch.ai/security/", id: "security" },
  { label: "Book a call", href: "https://cal.com/wondersearch/15min", id: "book-call" },
  { label: "Create an Account", href: "https://app.wondersearch.ai/", id: "create-account" },
];

export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="border-t border-[#233c4d]/20 bg-[#0b100d]"
  >
    <div className="mx-auto max-w-7xl px-6 py-14 md:px-12">
      <div className="flex flex-col justify-between gap-10 md:flex-row md:items-start">
        <div>
          <Wordmark />
          <p className="mt-3 max-w-xs text-sm leading-relaxed text-[#889296]">
            Serverless semantic search. Pay per query, with no upfront ingestion
            or embedding fees.
          </p>
        </div>
        <nav className="flex flex-col gap-3" aria-label="Footer">
          {LINKS.map((link) => (
            <a
              key={link.id}
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`footer-${link.id}-link`}
              className="inline-flex items-center gap-1.5 text-sm text-[#889296] transition-colors duration-200 hover:text-[#edf2f4]"
            >
              {link.label}
              <ArrowUpRight className="h-3.5 w-3.5" aria-hidden="true" />
            </a>
          ))}
        </nav>
      </div>
      <div className="mt-12 flex flex-col justify-between gap-3 border-t border-[#233c4d]/20 pt-6 sm:flex-row">
        <p className="font-mono text-xs text-[#889296]">
          © {new Date().getFullYear()} WonderSearch
        </p>
        <p className="font-mono text-xs text-[#889296]">
          Search so good it feels like magic.
        </p>
      </div>
    </div>
  </footer>
);
